// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + {"102":"xlsx","133":"pdfmake"}[chunkId] + "." + {"102":"a9a37d42","133":"6c1dee3a"}[chunkId] + ".chunk.js";
};